const LEGAL_TYPES = {
  TERMS_OF_SERVICE: 'terms-of-service',
  PAYMENT_TERMS: 'payment-terms',
  PRIVACY_POLICY: 'privacy-policy',
  INSURANCE: 'insurance',
  GUARANTEE: 'guarantee',
};

export { LEGAL_TYPES };